module.exports = __webpack_public_path__ + "img/house-church-walk_b1.40d5295b.jpg";